import i18next from "i18next";

export const actionParams = [
    {
        "Id": "INILA_GetCopy",
        "Group": [
            {
                "Name": "First",
                "Style": {marginTop: '5px', width: '100%'},
                "Group": [
                    {
                        "Name": "Common",
                        "Title": i18next.t("Common"),
                        "Style": {float: 'left', display: 'inline-block'},
                        "Parameter": [
                            {
                                "Name": "ICom_SurName",
                                "Title": i18next.t("ICom_SurName"),
                                "ShowInForm": true,
                                "ReadOnly": true
                            },
                            {
                                "Name": "ICom_FirstName",
                                "Title": i18next.t("ICom_FirstName"),
                                "ShowInForm": true,
                                "ReadOnly": true
                            },
                            {
                                "Name": "ICom_SecondName",
                                "Title": i18next.t("ICom_SecondName"),
                                "ShowInForm": true,
                                "ReadOnly": true
                            },
                            {
                                "Name": "ICom_Sex",
                                "Title": i18next.t("ICom_Sex"),
                                "ShowInForm": true,
                                "ReadOnly": true
                            },
                            {
                                "Name": "ICom_CitizenShip",
                                "Title": i18next.t("ICom_CitizenShip"),
                                "Size": "30",
                                "ShowInForm": true,
                                "ReadOnly": true
                            },
                            {
                                "Name": "ICom_Dob_Day",
                                "Title": i18next.t("ICom_Dob_Day"),
                                "Size": "2",
                                "ShowInForm": true,
                                "ReadOnly": true
                            },
                            {
                                "Name": "ICom_Dob_Month",
                                "Title": i18next.t("ICom_Dob_Month"),
                                "Size": "2",
                                "ShowInForm": true,
                                "ReadOnly": true
                            },
                            {
                                "Name": "ICom_Dob_Year",
                                "Title": i18next.t("ICom_Dob_Year"),
                                "Size": "2",
                                "ShowInForm": true,
                                "ReadOnly": true
                            },
                            {
                                "Name": "ICom_Phone",
                                "Title": i18next.t("ICom_Phone"),
                                "ShowInForm": true,
                                "ReadOnly": true
                            },
                            {
                                "Name": "PensNumber",
                                "Title": i18next.t("PensNumber"),
                                "Size": "10",
                                "ShowInForm": "False",
                                "ReadOnly": true
                            }
                        ]
                    },
                    {
                        "Name": "BirthdayPlace",
                        "Title": i18next.t("BirthdayPlace"),
                        "Style": {display: 'inline-block', marginLeft: '2%'},
                        "Parameter": [
                            {
                                "Name": "Bpl_Country",
                                "Title": i18next.t("Bpl_Country"),
                                "ShowInForm": true,
                                "ReadOnly": true
                            },
                            {
                                "Name": "Bpl_District",
                                "Title": i18next.t("Bpl_District"),
                                "ShowInForm": true,
                                "ReadOnly": true
                            },
                            {
                                "Name": "Bpl_Region",
                                "Title": i18next.t("Bpl_Region"),
                                "ShowInForm": true,
                                "ReadOnly": true
                            },
                            {
                                "Name": "Bpl_Settlement",
                                "Title": i18next.t("Bpl_Settlement"),
                                "ShowInForm": true,
                                "ReadOnly": true
                            }
                        ]
                    },
                    {
                        "Name": "Document",
                        "Title": i18next.t("Document"),
                        "Style": {display: 'inline-block', marginLeft: '2%'},
                        "Parameter": [
                            {
                                "Name": "IDoc_TypeId",
                                "Title": i18next.t("IDoc_TypeId"),
                                "ShowInForm": true,
                                "ReadOnly": true
                            },
                            {
                                "Name": "IDoc_DateGive",
                                "Title": i18next.t("IDoc_DateGive"),
                                "ShowInForm": true,
                                "ReadOnly": true
                            },
                            {
                                "Name": "IDoc_Number",
                                "Title": i18next.t("IDoc_Number"),
                                "Size": "10",
                                "ShowInForm": true,
                                "ReadOnly": true
                            },
                            {
                                "Name": "IDoc_SerRomNum",
                                "Title": i18next.t("IDoc_SerRomNum"),
                                "Size": "2",
                                "ShowInForm": true,
                                "ReadOnly": true
                            },
                            {
                                "Name": "IDoc_SerRusLet",
                                "Title": i18next.t("IDoc_SerRusLet"),
                                "Size": "2",
                                "ShowInForm": true,
                                "ReadOnly": true
                            },
                            {
                                "Name": "IDoc_WhoGive",
                                "Title": i18next.t("IDoc_WhoGive"),
                                "Size": "100",
                                "ShowInForm": true,
                                "ReadOnly": true
                            }
                        ]
                    }
                ]
            },
            {
                "Name": "Second",
                "Style": {width: '100%'},
                "Group": [
                    {
                        "Name": "OfficialAddress",
                        "Title": i18next.t("OfficialAddress"),
                        "Style": {float: 'left'},
                        "Group": [
                            {
                                "Name": "ForeignAddress",
                                "Parameter": [
                                    {
                                        "Name": "RAdr_ContryName",
                                        "Title": i18next.t("RAdr_ContryName"),
                                        "ShowInForm": true,
                                        "ReadOnly": true
                                    },
                                    {
                                        "Name": "RAdr_Address",
                                        "Title": i18next.t("RAdr_Address"),
                                        "Size": "100",
                                        "ShowInForm": true,
                                        "ReadOnly": true
                                    }
                                ]
                            },
                            {
                                "Name": "RussianAddress",
                                "Parameter": [
                                    {
                                        "Name": "RAdr_RegionName",
                                        "Title": i18next.t("RAdr_RegionName"),
                                        "ShowInForm": true,
                                        "ReadOnly": true
                                    },
                                    {
                                        "Name": "RAdr_CityName",
                                        "Title": i18next.t("RAdr_CityName"),
                                        "ShowInForm": true,
                                        "ReadOnly": true
                                    },
                                    {
                                        "Name": "RAdr_SettlementName",
                                        "Title": i18next.t("RAdr_SettlementName"),
                                        "ShowInForm": true,
                                        "ReadOnly": true
                                    },
                                    {
                                        "Name": "RAdr_DistrictName",
                                        "Title": i18next.t("RAdr_DistrictName"),
                                        "ShowInForm": true,
                                        "ReadOnly": true
                                    },
                                    {
                                        "Name": "RAdr_StreetName",
                                        "Title": i18next.t("RAdr_StreetName"),
                                        "ShowInForm": true,
                                        "ReadOnly": true
                                    },
                                    {
                                        "Name": "RAdr_HouseNo",
                                        "Title": i18next.t("RAdr_HouseNo"),
                                        "Size": "2",
                                        "ShowInForm": true,
                                        "ReadOnly": true
                                    },
                                    {
                                        "Name": "RAdr_BuildNo",
                                        "Title": i18next.t("RAdr_BuildNo"),
                                        "Size": "2",
                                        "ShowInForm": true,
                                        "ReadOnly": true
                                    },
                                    {
                                        "Name": "RAdr_ApartNo",
                                        "Title": i18next.t("RAdr_ApartNo"),
                                        "Size": "2",
                                        "ShowInForm": true,
                                        "ReadOnly": true
                                    },
                                    {
                                        "Name": "RAdr_Zip",
                                        "Title": i18next.t("RAdr_Zip"),
                                        "ShowInForm": true,
                                        "ReadOnly": true
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "Name": "FactAddress",
                        "Title": i18next.t("FactAddress"),
                        "Style": {display: 'inline-block', marginLeft: '2%'},
                        "Group": [
                            {
                                "Name": "ForeignAddress",
                                "Parameter": [
                                    {
                                        "Name": "FAdr_ContryName",
                                        "Title": i18next.t("FAdr_ContryName"),
                                        "ShowInForm": true,
                                        "ReadOnly": true
                                    },
                                    {
                                        "Name": "FAdr_Address",
                                        "Title": i18next.t("FAdr_Address"),
                                        "Size": "100",
                                        "ShowInForm": true,
                                        "ReadOnly": true
                                    }
                                ]
                            },
                            {
                                "Name": "RussianAddress",
                                "Parameter": [
                                    {
                                        "Name": "FAdr_RegionName",
                                        "Title": i18next.t("FAdr_RegionName"),
                                        "ShowInForm": true,
                                        "ReadOnly": true
                                    },
                                    {
                                        "Name": "FAdr_CityName",
                                        "Title": i18next.t("FAdr_CityName"),
                                        "ShowInForm": true,
                                        "ReadOnly": true
                                    },
                                    {
                                        "Name": "FAdr_SettlementName",
                                        "Title": i18next.t("FAdr_SettlementName"),
                                        "ShowInForm": true,
                                        "ReadOnly": true
                                    },
                                    {
                                        "Name": "FAdr_DistrictName",
                                        "Title": i18next.t("FAdr_DistrictName"),
                                        "ShowInForm": true,
                                        "ReadOnly": true
                                    },
                                    {
                                        "Name": "FAdr_StreetName",
                                        "Title": i18next.t("FAdr_StreetName"),
                                        "ShowInForm": true,
                                        "ReadOnly": true
                                    },
                                    {
                                        "Name": "FAdr_HouseNo",
                                        "Title": i18next.t("FAdr_HouseNo"),
                                        "Size": "2",
                                        "ShowInForm": true,
                                        "ReadOnly": true
                                    },
                                    {
                                        "Name": "FAdr_BuildNo",
                                        "Title": i18next.t("FAdr_BuildNo"),
                                        "Size": "2",
                                        "ShowInForm": true,
                                        "ReadOnly": true
                                    },
                                    {
                                        "Name": "FAdr_ApartNo",
                                        "Title": i18next.t("FAdr_ApartNo"),
                                        "Size": "2",
                                        "ShowInForm": true,
                                        "ReadOnly": true
                                    },
                                    {
                                        "Name": "FAdr_Zip",
                                        "Title": i18next.t("FAdr_Zip"),
                                        "ShowInForm": true,
                                        "ReadOnly": true
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        "Id": "INILA_Change",
        "Group": [
            {
                "Name": "First",
                "Style": {marginTop: '5px', width: '100%'},
                "Group": [
                    {
                        "Name": "Common",
                        "Title": i18next.t("Common"),
                        "Style": {float: 'left', display: 'inline-block'},
                        "Parameter": [
                            {
                                "Name": "ICom_SurName",
                                "Title": i18next.t("ICom_SurName"),
                                "ShowInForm": true,
                                "ReadOnly": true
                            },
                            {
                                "Name": "ICom_FirstName",
                                "Title": i18next.t("ICom_FirstName"),
                                "ShowInForm": true,
                                "ReadOnly": true
                            },
                            {
                                "Name": "ICom_SecondName",
                                "Title": i18next.t("ICom_SecondName"),
                                "ShowInForm": true,
                                "ReadOnly": true
                            },
                            {
                                "Name": "ICom_Sex",
                                "Title": i18next.t("ICom_Sex"),
                                "ShowInForm": true,
                                "ReadOnly": true
                            },
                            {
                                "Name": "ICom_CitizenShip",
                                "Title": i18next.t("ICom_CitizenShip"),
                                "Size": "30",
                                "ShowInForm": true,
                                "ReadOnly": true
                            },
                            {
                                "Name": "ICom_Dob_Day",
                                "Title": i18next.t("ICom_Dob_Day"),
                                "Size": "2",
                                "ShowInForm": true,
                                "ReadOnly": true
                            },
                            {
                                "Name": "ICom_Dob_Month",
                                "Title": i18next.t("ICom_Dob_Month"),
                                "Size": "2",
                                "ShowInForm": true,
                                "ReadOnly": true
                            },
                            {
                                "Name": "ICom_Dob_Year",
                                "Title": i18next.t("ICom_Dob_Year"),
                                "Size": "2",
                                "ShowInForm": true,
                                "ReadOnly": true
                            },
                            {
                                "Name": "ICom_Phone",
                                "Title": i18next.t("ICom_Phone"),
                                "ShowInForm": true,
                                "ReadOnly": true
                            },
                            {
                                "Name": "PensNumber",
                                "Title": i18next.t("PensNumber"),
                                "Size": "10",
                                "ShowInForm": "False",
                                "ReadOnly": true
                            }
                        ]
                    },
                    {
                        "Name": "BirthdayPlace",
                        "Title": i18next.t("BirthdayPlace"),
                        "Style": {display: 'inline-block', marginLeft: '2%'},
                        "Parameter": [
                            {
                                "Name": "Bpl_Country",
                                "Title": i18next.t("Bpl_Country"),
                                "ShowInForm": true,
                                "ReadOnly": true
                            },
                            {
                                "Name": "Bpl_District",
                                "Title": i18next.t("Bpl_District"),
                                "ShowInForm": true,
                                "ReadOnly": true
                            },
                            {
                                "Name": "Bpl_Region",
                                "Title": i18next.t("Bpl_Region"),
                                "ShowInForm": true,
                                "ReadOnly": true
                            },
                            {
                                "Name": "Bpl_Settlement",
                                "Title": i18next.t("Bpl_Settlement"),
                                "ShowInForm": true,
                                "ReadOnly": true
                            }
                        ]
                    },
                    {
                        "Name": "Document",
                        "Title": i18next.t("Document"),
                        "Style": {display: 'inline-block', marginLeft: '2%'},
                        "Parameter": [
                            {
                                "Name": "IDoc_TypeId",
                                "Title": i18next.t("IDoc_TypeId"),
                                "ShowInForm": true,
                                "ReadOnly": true
                            },
                            {
                                "Name": "IDoc_DateGive",
                                "Title": i18next.t("IDoc_DateGive"),
                                "ShowInForm": true,
                                "ReadOnly": true
                            },
                            {
                                "Name": "IDoc_Number",
                                "Title": i18next.t("IDoc_Number"),
                                "Size": "10",
                                "ShowInForm": true,
                                "ReadOnly": true
                            },
                            {
                                "Name": "IDoc_SerRomNum",
                                "Title": i18next.t("IDoc_SerRomNum"),
                                "Size": "2",
                                "ShowInForm": true,
                                "ReadOnly": true
                            },
                            {
                                "Name": "IDoc_SerRusLet",
                                "Title": i18next.t("IDoc_SerRusLet"),
                                "Size": "2",
                                "ShowInForm": true,
                                "ReadOnly": true
                            },
                            {
                                "Name": "IDoc_WhoGive",
                                "Title": i18next.t("IDoc_WhoGive"),
                                "Size": "100",
                                "ShowInForm": true,
                                "ReadOnly": true
                            }
                        ]
                    }
                ]
            },
            {
                "Name": "Second",
                "Style": {width: '100%'},
                "Group": [
                    {
                        "Name": "OfficialAddress",
                        "Title": i18next.t("OfficialAddress"),
                        "Style": {float: 'left'},
                        "Group": [
                            {
                                "Name": "ForeignAddress",
                                "Parameter": [
                                    {
                                        "Name": "RAdr_ContryName",
                                        "Title": i18next.t("RAdr_ContryName"),
                                        "ShowInForm": true,
                                        "ReadOnly": true
                                    },
                                    {
                                        "Name": "RAdr_Address",
                                        "Title": i18next.t("RAdr_Address"),
                                        "Size": "100",
                                        "ShowInForm": true,
                                        "ReadOnly": true
                                    }
                                ]
                            },
                            {
                                "Name": "RussianAddress",
                                "Parameter": [
                                    {
                                        "Name": "RAdr_RegionName",
                                        "Title": i18next.t("RAdr_RegionName"),
                                        "ShowInForm": true,
                                        "ReadOnly": true
                                    },
                                    {
                                        "Name": "RAdr_CityName",
                                        "Title": i18next.t("RAdr_CityName"),
                                        "ShowInForm": true,
                                        "ReadOnly": true
                                    },
                                    {
                                        "Name": "RAdr_SettlementName",
                                        "Title": i18next.t("RAdr_SettlementName"),
                                        "ShowInForm": true,
                                        "ReadOnly": true
                                    },
                                    {
                                        "Name": "RAdr_DistrictName",
                                        "Title": i18next.t("RAdr_DistrictName"),
                                        "ShowInForm": true,
                                        "ReadOnly": true
                                    },
                                    {
                                        "Name": "RAdr_StreetName",
                                        "Title": i18next.t("RAdr_StreetName"),
                                        "ShowInForm": true,
                                        "ReadOnly": true
                                    },
                                    {
                                        "Name": "RAdr_HouseNo",
                                        "Title": i18next.t("RAdr_HouseNo"),
                                        "Size": "2",
                                        "ShowInForm": true,
                                        "ReadOnly": true
                                    },
                                    {
                                        "Name": "RAdr_BuildNo",
                                        "Title": i18next.t("RAdr_ApartNo"),
                                        "Size": "2",
                                        "ShowInForm": true,
                                        "ReadOnly": true
                                    },
                                    {
                                        "Name": "RAdr_ApartNo",
                                        "Title": i18next.t("RAdr_ApartNo"),
                                        "Size": "2",
                                        "ShowInForm": true,
                                        "ReadOnly": true
                                    },
                                    {
                                        "Name": "RAdr_Zip",
                                        "Title": i18next.t("RAdr_Zip"),
                                        "ShowInForm": true,
                                        "ReadOnly": true
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "Name": "FactAddress",
                        "Title": i18next.t("FactAddress"),
                        "Style": {display: 'inline-block', marginLeft: '2%'},
                        "Group": [
                            {
                                "Name": "ForeignAddress",
                                "Parameter": [
                                    {
                                        "Name": "FAdr_ContryName",
                                        "Title": i18next.t("FAdr_ContryName"),
                                        "ShowInForm": true,
                                        "ReadOnly": true
                                    },
                                    {
                                        "Name": "FAdr_Address",
                                        "Title": i18next.t("FAdr_Address"),
                                        "Size": "100",
                                        "ShowInForm": true,
                                        "ReadOnly": true
                                    }
                                ]
                            },
                            {
                                "Name": "RussianAddress",
                                "Parameter": [
                                    {
                                        "Name": "FAdr_RegionName",
                                        "Title": i18next.t("FAdr_RegionName"),
                                        "ShowInForm": true,
                                        "ReadOnly": true
                                    },
                                    {
                                        "Name": "FAdr_CityName",
                                        "Title": i18next.t("FAdr_CityName"),
                                        "ShowInForm": true,
                                        "ReadOnly": true
                                    },
                                    {
                                        "Name": "FAdr_SettlementName",
                                        "Title": i18next.t("FAdr_SettlementName"),
                                        "ShowInForm": true,
                                        "ReadOnly": true
                                    },
                                    {
                                        "Name": "FAdr_DistrictName",
                                        "Title": i18next.t("FAdr_DistrictName"),
                                        "ShowInForm": true,
                                        "ReadOnly": true
                                    },
                                    {
                                        "Name": "FAdr_StreetName",
                                        "Title": i18next.t("FAdr_StreetName"),
                                        "ShowInForm": true,
                                        "ReadOnly": true
                                    },
                                    {
                                        "Name": "FAdr_HouseNo",
                                        "Title": i18next.t("FAdr_HouseNo"),
                                        "Size": "2",
                                        "ShowInForm": true,
                                        "ReadOnly": true
                                    },
                                    {
                                        "Name": "FAdr_BuildNo",
                                        "Title": i18next.t("FAdr_ApartNo"),
                                        "Size": "2",
                                        "ShowInForm": true,
                                        "ReadOnly": true
                                    },
                                    {
                                        "Name": "FAdr_ApartNo",
                                        "Title": i18next.t("FAdr_ApartNo"),
                                        "Size": "2",
                                        "ShowInForm": true,
                                        "ReadOnly": true
                                    },
                                    {
                                        "Name": "FAdr_Zip",
                                        "Title": i18next.t("FAdr_Zip"),
                                        "ShowInForm": true,
                                        "ReadOnly": true
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }
]